<template>
  <iframe class="unpakt-widget" src="https://www.unpakt.com/affiliates-widget/"></iframe>
</template>
<script>

export default {
  name: 'unpakt',
  props: {
  },
};
</script>

<style lang='scss' scoped>
.unpakt-widget {
  width: 100%;
  min-height: 720px;
}
</style>
